import { Badge, ThemeProvider, Tooltip } from '@alphonsocode/kallos';
import React from 'react';
import { MdClear } from 'react-icons/md';

interface BadgeItem {
  key: string;
  value: string;
  showFullValue?: boolean;
}

interface BadgesProps {
  items: BadgeItem[];
  onClose?: (index: number) => void;
  variant: string;
  enableTooltip?: boolean;
}

export default function Badges({
  items,
  onClose,
  variant,
  enableTooltip = true,
}: BadgesProps) {
  const legacyVariantMap: Record<string, string> = {
    lgRed: 'red',
    lgGreen: 'green',
    lgDeepGreen: 'deepGreen',
    lgDarkGreen: 'darkGreen',
    lgWebGreen: 'webGreen',
    lgLightPurple: 'lightPurple',
    lgGray: 'gray',
    rounded: 'deepGreen',
  };

  const colorVariant = legacyVariantMap[variant] || variant;

  return (
    <div
      className="badge-container"
      style={{ display: 'flex', alignItems: 'center' }}
    >
      {/* @ts-ignore - ThemeProvider children type issue with React 18 */}
      <ThemeProvider defaultMode="light">
        {items.map((item, index) => {
          const badge = (
            <Badge
              pill
              colorVariant={colorVariant}
              size="sm"
              key={index}
              style={{
                fontFamily: 'lg-smart, sans-serif',
                fontSize: '12px',
                lineHeight: '18px',
                marginRight: 2,
                display: 'inline-block',
                width: item.showFullValue
                  ? 'auto'
                  : `${Math.min(
                      ((item.key + item.value).length + 5) * 8,
                      185,
                    )}px`,
                overflow: item.showFullValue ? 'visible' : 'hidden',
                textOverflow: item.showFullValue ? 'initial' : 'ellipsis',
                whiteSpace: item.showFullValue ? 'normal' : 'nowrap',
                position: 'relative',
                paddingRight: '25px',
                textAlign: 'left',
                fontWeight: 600,
                marginLeft: '3px',
              }}
            >
              {item.value ? `${item.key}: ${item.value}` : item.key}
              {onClose && (
                <button
                  className="tag-remove"
                  style={{
                    background: 'transparent',
                    border: 'none',
                    padding: 0,
                    position: 'absolute',
                    top: '50%',
                    right: 5,
                    transform: 'translateY(-50%)',
                    cursor: 'pointer',
                  }}
                  onClick={() => onClose(index)}
                >
                  <MdClear size={15} color="black" />
                </button>
              )}
            </Badge>
          );

          return enableTooltip ? (
            <Tooltip
              overlay={
                item.value.includes(',') ? (
                  <div>
                    {item.value.split(',').map((v, i) => (
                      <div key={i}>• {v.trim()}</div>
                    ))}
                  </div>
                ) : (
                  item.value
                )
              }
              openDelay={0}
              closeDelay={0}
              arrow={false}
              style={{
                maxWidth: '300px',
                whiteSpace: 'normal',
                wordBreak: 'break-word',
                marginTop: 5,
              }}
            >
              {badge}
            </Tooltip>
          ) : (
            badge
          );
        })}
      </ThemeProvider>
    </div>
  );
}
